import { useState, useEffect } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

export function useAdSense() {
  const [config, setConfig] = useState({ enabled: false, clientId: '', slotInArticle: '', slotHomepage: '' });

  useEffect(() => {
    axios.get(`${API}/api/admin/adsense`).then(r => {
      const d = r.data;
      setConfig({
        enabled: d.adsense_enabled || false,
        clientId: d.adsense_client_id || '',
        slotInArticle: d.adsense_slot_in_article || '',
        slotHomepage: d.adsense_slot_homepage || '',
      });
    }).catch(() => {});
  }, []);

  return config;
}

export function AdInArticle({ className = '' }) {
  const { enabled, clientId, slotInArticle } = useAdSense();
  if (!enabled || !clientId || !slotInArticle) return null;

  return (
    <div className={`my-6 text-center ${className}`} data-testid="ad-in-article">
      <ins
        className="adsbygoogle"
        style={{ display: 'block' }}
        data-ad-client={clientId}
        data-ad-slot={slotInArticle}
        data-ad-format="auto"
        data-full-width-responsive="true"
      />
      <p className="text-[10px] text-gray-400 mt-1">Oglas</p>
    </div>
  );
}

export function AdHomepageBottom({ className = '' }) {
  const { enabled, clientId, slotHomepage } = useAdSense();
  if (!enabled || !clientId || !slotHomepage) return null;

  return (
    <div className={`my-8 text-center ${className}`} data-testid="ad-homepage-bottom">
      <ins
        className="adsbygoogle"
        style={{ display: 'block' }}
        data-ad-client={clientId}
        data-ad-slot={slotHomepage}
        data-ad-format="auto"
        data-full-width-responsive="true"
      />
      <p className="text-[10px] text-gray-400 mt-1">Oglas</p>
    </div>
  );
}
